<template>
    <Loading :loading="loading" class="min-h-screen">
        <div class="min-h-screen w-full bg-[#f1f6fa] px-6 lg:px-20 lg:py-10 flex flex-col gap-6">
            <MarketsHeader v-if="!currentProductGroupLoading" :current-product-group="currentProductGroup" />
            <div class="flex flex-col lg:flex-row gap-4">
                <TradingviewChart v-if="productGroupId" :product-id="productGroupId" layout="single" class="w-full lg:w-2/3 bg-white rounded-xl p-10 xl:px-4 h-fit shadow-md" />
                <ContentstreamsListV2
                    v-if="currentProductGroup?.products?.data"
                    :init-filter="['short', 'webinar', 'wmu', 'dsu', 'dmu']"
                    :show-dropdown="false"
                    :page-size="40"
                    class="w-full lg:w-1/3 shadow-md"
                    :product-id="currentProductGroup?.products?.data[0].id"
                ></ContentstreamsListV2>
            </div>

            <Sheet v-if="currentProductGroup && productIds.length > 0">
                <MarketsSocials :current-product-group="currentProductGroup" :product-ids="productIds" />
            </Sheet>
        </div>
    </Loading>
</template>

<script setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import Loading from '../../miscellaneous/Loading.vue';
import Sheet from '../../Sheet.vue';
import ContentstreamsListV2 from '../ContentstreamsListV2.vue';
import MarketsHeader from '../MarketsHeader.vue';
import MarketsSocials from '../MarketsSocials.vue';
import TradingviewChart from '../TradingviewChart.vue';

const store = useStore();
const route = useRoute();
const productGroupId = route.params.id;
const contentstreams = ref([]);
const contentstreamIsLoaded = computed(() => store.getters['contentstreams/all'].dashboard);
const currentProductGroup = ref({});
const currentProductGroupName = ref('');
const currentProductGroupDescription = ref('');
let currentProductGroupLoading = true;
const currentProducts = ref({});
const loading = ref(true);
const tabs = ref([]);
const productIds = ref([]);

/**
 * Get contentstreams by product id
 * @param ids of products in current Productgroup string
 */
const fetchContentstreamsByProductIds = async (ids) => {
    const get = await store.getters['contentstreams/all'];
    contentstreams.value = get?.dashboard?.data.filter((item) => ids.includes(item.product_id)).sort((a, b) => new Date(b.published_at) - new Date(a.published_at));

    loading.value = false;
};

/**
 * Fetches the product group by its ID and updates the relevant state.
 *
 * @param {string} id - The ID of the product group to fetch.
 */
const fetchProductGroup = (id) => {
    currentProductGroup.value = {};

    store.dispatch('product_group/show', id).then(() => {
        currentProductGroup.value = store.getters['product_group/get'];
        currentProductGroupName.value = currentProductGroup.value.name.de;
        currentProductGroupDescription.value = currentProductGroup.value.description.de;
        currentProducts.value = currentProductGroup.value.products.data;

        for (const i in currentProductGroup.value.products.data) {
            productIds.value.push(currentProducts.value[i].id);
        }

        fetchContentstreamsByProductIds(productIds.value);
        currentProductGroupLoading = false;
        loading.value = false;
    });
};

const resetProductGroupData = (newId) => {
    contentstreams.value = [];
    currentProductGroupLoading = true;
    currentProductGroup.value = {};
    currentProductGroupName.value = '';
    currentProductGroupDescription.value = '';
    currentProducts.value = {};
    loading.value = true;
    tabs.value = [];
    productIds.value = [];

    fetchProductGroup(newId);
};

onMounted(() => {
    fetchProductGroup(productGroupId);
});

watch(
    () => route.params.id,
    (newId, oldId) => {
        if (newId !== oldId && route.name.includes('markets-')) {
            resetProductGroupData(newId);
        }
    }
);

watch([contentstreamIsLoaded, productIds.value], ([isLoaded, ids]) => {
    console.log('W: ', ids);

    if (isLoaded && ids.length) {
        fetchContentstreamsByProductIds(ids);
    }
});
</script>

<style scoped>
@media not all and (min-width: 1280px) {
    iframe {
        height: 500px !important;
    }
}
</style>
